/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShopProductDto } from '../../models/shop-product-dto';

export interface ShopProductControllerFindById$Params {

/**
 * 상품 ID
 */
  id: string;
}

export function shopProductControllerFindById(http: HttpClient, rootUrl: string, params: ShopProductControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopProductDto>> {
  const rb = new RequestBuilder(rootUrl, shopProductControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShopProductDto>;
    })
  );
}

shopProductControllerFindById.PATH = '/api/shop-products/{id}';
